import { store } from '../../store';
import { updateUserLastLogin } from '../../ReduxSlices/Admin/userSlice';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribeUser = null;

export const initializeUserSubscription = () => {
  if (unsubscribeUser) return;

  unsubscribeUser = subscribeToCoreUpdates("user", {
    "user.login_updated": (data) => {
      if (data?.id) {
        store.dispatch(updateUserLastLogin(data));
      }
    }
  });

 // console.log("✅ User subscription initialized");
};

export const unsubscribeUserSubscription = () => {
  if (unsubscribeUser) {
    unsubscribeUser();
    unsubscribeUser = null;
   // console.log("🔌 User subscription removed");
  }
};